import React from "react";
import "./Summary.scss"

class Summary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
        };
        
    }

    // <h1 className="center">Project Description</h1>
    // <div className="sponsorsDiscription">
    //     Agricultural farming is the stepping stone for life as we know it today. The industry has changed drastically since the first farms, with advancements in technology, crop cycling, and new concepts. Precision Agriculture (PA) is one of these concepts, which is based on observing, measuring and responding to inter and intra-field variability in crops; with the goal of responding to varying conditions to maximize yield.
    // </div>
    // <div className="sponsorsDiscription">
    //     Current PA solutions are expensive and often only address a minute set of factors that may contribute to suboptimal crop yield. The goal of AgriBoost is to cover a wider array of factors than other solutions on the market at a much lower price point.
    // </div>


	render() {
		return (
			<div className="summarySection" ref={this.props.refs}>
                
                
                {/* <div className="video_container">
					<iframe className="center video"  src="https://www.youtube.com/embed/ugzj0PhFkpk?cc_load_policy=1&cc_lang_pref=en" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen/>
				</div> */}



                {/* <h1 className="center">Project Description</h1> */}
                <div className="split">
                    <div className="left">
                        <h3>What is AgriBoost?</h3>
                        {/* <p>Agricultural farming is the stepping stone for life as we know it today. The industry has changed drastically since the first farms, with advancements in technology, crop cycling, and new concepts. Precision Agriculture (PA) is one of these concepts, which is based on observing, measuring and responding to inter and intra-field variability in crops; with the goal of responding to varying conditions to maximize yield.</p> */}
                        <p>AgriBoost is a precision agriculture system, designed to help farmers understand and react to what is happening in their fields in real time. The AgriBoost system consists of a network of nodes that collect agricultural data for fields of varying sizes. This data is then analyzed and presented to the farmers on a web based dashboard. We help farmers act proactively and optimize their overall resource utilization.</p>
                    </div>
                    <div className="right end">
                        {/* <img
                            className=""
                            src={require("assets/img/Edit2_istockphoto-1093092328-170667a.jpg")}
                        /> */}
                        <div className="video_container">
                            <iframe className="center video"  src="https://www.youtube.com/embed/ugzj0PhFkpk?cc_load_policy=1&cc_lang_pref=en" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowFullScreen/>
                        </div>
                    </div>
                </div>

                <div className="split reverse">
                    <div className="right start">
                        <img
                            className=""
                            src={require("assets/img/Edit2_istockphoto-1093092328-170667a.jpg")}

                            // src={require("assets/img/DSC_0052.jpg")}
                        />
                    </div>
                    <div className="left">
                        <h3>What is Precision agriculture?</h3>
                        <p>Precision agriculture is a method of farming that uses technological in order to grow crops more efficiently. These technologies and techniques help farmers make more informed decisions about their crops based on the unique nature of their fields. This enables them to do the right thing, in the right place, at the right time. For farmers, this has obvious benefits: they can grow more, and healthier crops on the same amount of land and increase the economic viability of their farms in a way that’s better for the environment. </p>
                    </div>
                </div>

			</div>
		);
	}
}
export default Summary;
